import React from "react";

import InsightsSmall from "assets/images/icons/JSX/InsightsSmall";
import InsightsHybridHeating from "assets/images/icons/JSX/InsightsHybridHeating";
import InsightsSingleZoneCooling from "assets/images/icons/JSX/InsightsSingleZoneCooling";
import House from "assets/images/icons/JSX/House";
import Settings from "assets/images/icons/JSX/Settings";
import CommunitiesIcon from "assets/images/icons/JSX/CommunitiesIcon";
import SharedModel from "assets/images/icons/JSX/SharedModel";

const ICON_BLUE = "#0049C6";

const InsightsIcon = () => <InsightsSmall fill={ICON_BLUE} />;
const ReferenceHouseIcon = () => <House color={ICON_BLUE} />;
const SocIcon = () => <Settings />;
const HybridHeatingIcon = () => <InsightsHybridHeating fill={ICON_BLUE} />;
const SingleZoneCoolingIcon = () => <InsightsSingleZoneCooling fill={ICON_BLUE} />;
const OrganizationIcon = () => <SharedModel />;
const CommunityIcon = () => <CommunitiesIcon />;

/** Slide config for the Volta SNAP 1.1.0 dashboard announcement. */
export const VERSION_ID = "1.1.0";

export const EYEBROW = "New in 1.1";

export const SLIDES = [
    {
        id: "launch",
        title: "Volta SNAP 1.1",
        description:
            "Reference houses, hybrid heating, single zone cooling, community analysis, and organization updates are now available.",
        cta: { label: "View updates", to: "/updates" },
        Icon: InsightsIcon,
    },
    {
        id: "reference-houses",
        title: "Reference Houses",
        description: "Build NBC 2015, NBC 2020, NBC 2025, or Ontario SB-12 reference houses from your models.",
        cta: { label: "Learn more", to: "/updates" },
        Icon: ReferenceHouseIcon,
    },
    {
        id: "soc-approximation",
        title: "SOC Approximation",
        description:
            "Approximate standard operating conditions in General mode files for quick comparisons and exploratory analysis.",
        cta: { label: "Learn more", to: "/updates" },
        Icon: SocIcon,
    },
    {
        id: "hybrid-heating",
        title: "Hybrid Heating",
        description:
            "Find the optimal switchover temperature for an air-source heat pump with fossil-fuel backup. Free until April 2027.",
        cta: { label: "Learn more", to: "/updates" },
        Icon: HybridHeatingIcon,
    },
    {
        id: "single-zone-cooling",
        title: "Single Zone Cooling",
        description:
            "Based on the Guideline on Single Zone Cooling in Dwelling Units. A complete room-by-room analysis is required first.",
        cta: { label: "Learn more", to: "/updates" },
        Icon: SingleZoneCoolingIcon,
    },
    {
        id: "organizations",
        title: "Organizations",
        description: "Updates to organization capabilities, including shared folders and code libraries.",
        cta: { label: "Learn more", to: "/updates" },
        Icon: OrganizationIcon,
        forceIconBlue: true,
    },
    {
        id: "community-analysis",
        title: "Community Analysis",
        description:
            "Run multi-file community analyses, unlock runs with credits, and view how upgrades impact the community.",
        cta: { label: "Learn more", to: "/updates" },
        Icon: CommunityIcon,
        forceIconBlue: true,
    },
];
